import { GeofenceEntity } from './GeofenceEntity';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { GeocodeRequester } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

import { changeGeofenceAddressSucceeded, changeGeofenceCoordinateSucceeded, clearGeofence } from '@cobliteam/store/src/GeofenceForm/actionCreators';
import type { ChangeGeofenceAddressRequest, ChangeGeofenceCoordinateRequest } from '@cobliteam/store/src/GeofenceForm/actions';
import { ActionTypes } from '@cobliteam/store/src/GeofenceForm/actionTypes';

import Alert from '@cobliteam/ui/components/Alert';

const env = Environment.getInstance().getEnvironment();
const geocodeRequester = new GeocodeRequester({ host: env.herbieApiHost });

export function* changeGeofenceAddressSaga(action: ChangeGeofenceAddressRequest) {
  try {
    const geofence = action.payload;
    let address = geofence.address;

    if (!geofence.centerLatLong) {
      yield put(clearGeofence());
      return;
    }

    if (address) {
      yield put(changeGeofenceAddressSucceeded(geofence));
      return;
    }

    const latLng = {
      lat: geofence.centerLatLong.latitude,
      lng: geofence.centerLatLong.longitude,
    };

    address = yield call(geocodeRequester.getAddress, latLng);

    const newGeofence = new GeofenceEntity(geofence.id, address, geofence.name, geofence.radius, geofence.createdAt, geofence.centerLatLong, geofence.geojson, geofence.category);

    yield put(changeGeofenceAddressSucceeded(newGeofence));
  } catch (err) {
    Alert.error('Falha ao carregar o endereço do local de interesse. Tente novamente mais tarde.');
  }
}

export function* changeGeofenceCoordinateRequestSaga(action: ChangeGeofenceCoordinateRequest) {
  try {
    const geofence = action.payload;

    const newGeofence = new GeofenceEntity(
      geofence.id,
      geofence.address,
      geofence.name,
      geofence.radius,
      geofence.createdAt,
      geofence.centerLatLong,
      geofence.geojson,
      geofence.category
    );

    yield put(changeGeofenceCoordinateSucceeded(newGeofence));
  } catch (err) {
    Alert.error('Falha ao mudar o endereço do local de interesse. Tente novamente mais tarde.');
  }
}

export function* GeofenceFormSagasListener() {
  yield all([
    takeLatest(ActionTypes.CHANGE_GEOFENCE_ADDRESS_REQUEST, changeGeofenceAddressSaga),
    takeLatest(ActionTypes.CHANGE_GEOFENCE_COORDINATE_REQUEST, changeGeofenceCoordinateRequestSaga),
  ]);
}
